import * as Types from "../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GetManageCollectionQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type GetManageCollectionQuery = {
  getManageCollection: {
    __typename: "ManageCollection";
    id: string;
    onchainId: string;
    name: string;
    description: string | null;
    collectionType: Types._CollectionType;
    address: string;
    baseUri: string | null;
    onChainBaseUri: string | null;
    chainId: number;
    status: Types.CollectionStatus;
    usingOpenseaBlocklist: boolean | null;
    createdAt: string;
    contractId: string;
    size: number | null;
    reveal: boolean | null;
    editionId: string | null;
    creditCardEnabled: boolean | null;
    archivedAt: string | null;
    hidden: boolean | null;
    nonTransferable: boolean | null;
    mintVectors: Array<{
      __typename: "ManageCollectionSale";
      id: string | null;
      gateId: string | null;
      start: string;
      end: string | null;
      price: string;
      chainId: number | null;
      currency: string;
      maxPerTxn: number;
      maxPerUser: number;
      maxPerVector: number;
      paused: boolean | null;
      paymentRecipient: string;
      ethRate: string | null;
      priceType: Types.PriceType | null;
      scheduledPrices: Array<string> | null;
      isDirectMint: boolean | null;
      onchainMintVectorId: string | null;
      collectorMessage: string | null;
      name: string | null;
      isPublic: boolean | null;
      paymentCurrency: {
        __typename: "Currency";
        symbol: Types.CurrencySymbol;
        type: Types.CurrencyType;
        mintFee: string;
        decimals: number;
        address: string;
      } | null;
      stats: {
        __typename: "MintVectorStats";
        total: number;
        sold: number;
        status: Types.MintVectorStatus;
        earned: string | null;
        onchainDutchAuctionStats: {
          __typename: "OnchainDutchAuctionStats";
          earnedAmountIsValid: boolean;
          inFPP: boolean;
          exhausted: boolean;
          revenueWithdrawnFromEscrow: boolean;
          fundsToClaim: string;
          currentPrice: string;
        } | null;
      } | null;
      priceDrops: Array<{
        __typename: "PriceDrop";
        price: string;
        end: string;
        active: boolean;
      }> | null;
      priceDropInterval: Array<{
        __typename: "PriceDropTimePeriod";
        unit: Types.TimeUnit;
        value: number;
      }> | null;
      rankedAuction: {
        __typename: "RankedAuctionSettings";
        reserveBidAmount: string | null;
        rebateWinningBids: boolean | null;
      } | null;
    }>;
    editions: Array<{
      __typename: "EditionToken";
      name: string;
      description: string;
      image: string;
      animation: string | null;
      size: number;
      onChainImage: string;
      onChainMetadata: string | null;
      nonTransferable: boolean | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyRecipient: string | null;
        royaltyPercentageString: string | null;
      } | null;
      attributes: Array<{
        __typename: "TokenMetadataAttribute";
        trait_type: string;
        value: string;
      }> | null;
    }> | null;
    tokens: Array<{
      __typename: "GeneralToken";
      animation_url: string | null;
      image: string;
      name: string;
      description: string;
      id: string;
      nonTransferable: boolean | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyPercentageString: string | null;
        royaltyRecipient: string | null;
      } | null;
    }> | null;
    importData: {
      __typename: "ImportData";
      description: string | null;
      media: string | null;
      standard: string | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyRecipient: string | null;
        royaltyPercentageString: string | null;
      } | null;
    } | null;
    seriesDetails: {
      __typename: "SeriesDetails";
      coverImage: number;
      mintPreviewImages: Array<number>;
      mintPreviewImageUrls: Array<string> | null;
      showAllMetadata: boolean | null;
      mirroredBaseUri: string | null;
      logoUrl: string | null;
      featuredTokenId: string | null;
    } | null;
    generativeDetails: {
      __typename: "GenerativeDetails";
      logoUrl: string | null;
      generativeCodeUri: string;
      mirroredBaseUri: string | null;
      allowedHashes: Array<string> | null;
      featuredTokenId: string | null;
    } | null;
    crossmint: {
      __typename: "CrossmintEnv";
      collectionId: string;
      projectId: string | null;
      environment: string;
    } | null;
    contract: {
      __typename: "ManageCollectionContract";
      contractAddress: string | null;
      type: Types.ContractEntityType;
      name: string;
      symbol: string;
    } | null;
    flagVariations: {
      __typename: "CollectionFlagVariations";
      multipleMintVectorsEnableManagement: boolean;
      multipleMintVectorsEnableMultipleDA: boolean;
    };
  };
};

export const GetManageCollectionDocument = gql`
  query GetManageCollection($collectionId: String!) {
    getManageCollection(collectionId: $collectionId) {
      id
      onchainId
      name
      description
      collectionType
      address
      baseUri
      onChainBaseUri
      chainId
      status
      mintVectors {
        id
        gateId
        start
        end
        price
        chainId
        currency
        paymentCurrency {
          symbol
          type
          mintFee
          decimals
          address
          __typename
        }
        maxPerTxn
        maxPerUser
        maxPerVector
        paused
        paymentRecipient
        ethRate
        stats {
          total
          sold
          status
          earned
          onchainDutchAuctionStats {
            earnedAmountIsValid
            inFPP
            exhausted
            revenueWithdrawnFromEscrow
            fundsToClaim
            currentPrice
            __typename
          }
          __typename
        }
        priceDrops {
          price
          end
          active
          __typename
        }
        priceType
        scheduledPrices
        priceDropInterval {
          unit
          value
          __typename
        }
        rankedAuction {
          reserveBidAmount
          rebateWinningBids
          __typename
        }
        isDirectMint
        onchainMintVectorId
        collectorMessage
        name
        isPublic
        __typename
      }
      editions {
        name
        description
        image
        animation
        size
        onChainImage
        onChainMetadata
        royalty {
          royaltyRecipient
          royaltyPercentageString
          __typename
        }
        nonTransferable
        attributes {
          trait_type
          value
          __typename
        }
        __typename
      }
      tokens {
        animation_url
        image
        name
        description
        id
        nonTransferable
        royalty {
          royaltyPercentageString
          royaltyRecipient
          __typename
        }
        __typename
      }
      importData {
        description
        media
        royalty {
          royaltyRecipient
          royaltyPercentageString
          __typename
        }
        standard
        __typename
      }
      usingOpenseaBlocklist
      createdAt
      contractId
      size
      seriesDetails {
        coverImage
        mintPreviewImages
        mintPreviewImageUrls
        showAllMetadata
        mirroredBaseUri
        logoUrl
        featuredTokenId
        __typename
      }
      generativeDetails {
        logoUrl
        generativeCodeUri
        mirroredBaseUri
        generativeCodeUri
        allowedHashes
        featuredTokenId
        __typename
      }
      reveal
      editionId
      creditCardEnabled
      crossmint {
        collectionId
        projectId
        environment
      }
      archivedAt
      hidden
      nonTransferable
      contract {
        contractAddress
        type
        name
        symbol
        type
        __typename
      }
      flagVariations {
        multipleMintVectorsEnableManagement
        multipleMintVectorsEnableMultipleDA
      }
    }
  }
`;

/**
 * __useGetManageCollectionQuery__
 *
 * To run a query within a React component, call `useGetManageCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetManageCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageCollectionQuery,
    GetManageCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManageCollectionQuery,
    GetManageCollectionQueryVariables
  >(GetManageCollectionDocument, options);
}
export function useGetManageCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageCollectionQuery,
    GetManageCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManageCollectionQuery,
    GetManageCollectionQueryVariables
  >(GetManageCollectionDocument, options);
}
export type GetManageCollectionQueryHookResult = ReturnType<
  typeof useGetManageCollectionQuery
>;
export type GetManageCollectionLazyQueryHookResult = ReturnType<
  typeof useGetManageCollectionLazyQuery
>;
export type GetManageCollectionQueryResult = Apollo.QueryResult<
  GetManageCollectionQuery,
  GetManageCollectionQueryVariables
>;
